import {
  HttpStatusCode,
  type HttpErrorResponse,
  type HttpEvent,
  type HttpHandler,
  type HttpInterceptor,
  type HttpRequest
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigProperty, ConfigService } from '@sds/shared';
import { OAuthService } from 'angular-oauth2-oidc';
import { type Observable, from, switchMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
  private readonly configService = inject(ConfigService);
  private readonly oauthService = inject(OAuthService);

  intercept(req: HttpRequest<never>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let retried = false;
    if (req.url.startsWith(this.configService.get(ConfigProperty.BaseApiUrl))) {
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          // if 401 error, refresh the token and repeat the request
          if (!retried && error.status === HttpStatusCode.Unauthorized) {
            retried = true;
            return from(this.oauthService.refreshToken()).pipe(switchMap(() => next.handle(req.clone())));
          }
          return throwError(() => error);
        })
      );
    }

    return next.handle(req);
  }
}
